import React from 'react';
import PropTypes from 'prop-types';
import { DonorRelationType, DonorType } from '@/propTypes';
import AddMissingDataLink from './AddMissingDataLink';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConstituentHoverCard from './ConstituentHoverCard';
import ConstituentRelationCard from './ConstituentRelationCard';
import ConstituentSectionWrapper from './ConstituentSectionWrapper';

function ConstituentRelationsList({
  actionLabel,
  isEditable,
  onAddRelation,
  parent,
  relations,
  renderCardActions,
  title,
}) {
  const hasRelations = !!relations?.length;
  const [constituentPreview, setConstituentPreview] = React.useState(null);

  const handleHover = (e, constituentId) => {
    setConstituentPreview({
      anchorEl: e.target,
      constituentId,
    });
  };

  const handleClose = () => {
    setConstituentPreview(null);
  };

  let contents = null;
  if (hasRelations) {
    contents = relations.map((relation) => (
      <ConstituentRelationCard
        key={relation.relatedId}
        onNameHover={(e) => handleHover(e, relation.relatedId)}
        onClose={handleClose}
        parent={parent}
        relation={relation}
        renderActions={renderCardActions}
      />
    ));
  } else if (isEditable) {
    contents = (
      <AddMissingDataLink label={actionLabel} onClick={onAddRelation} />
    );
  }

  return (
    <ConstituentSectionWrapper
      actionLabel={actionLabel}
      isEditable={isEditable}
      onActionClick={onAddRelation}
      title={title}
    >
      <div className="-mx-4 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
        {contents}
      </div>
      <ConstituentHoverCard
        {...constituentPreview}
        open={!!constituentPreview}
        onClose={handleClose}
      />
    </ConstituentSectionWrapper>
  );
}

ConstituentRelationsList.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  parent: DonorType.isRequired,
  relations: PropTypes.arrayOf(DonorRelationType),
  isEditable: PropTypes.bool,
  onAddRelation: PropTypes.func,
  renderCardActions: PropTypes.func,
};

ConstituentRelationsList.defaultProps = {
  relations: [],
  isEditable: false,
  onAddRelation: () => {},
  renderCardActions: null,
};

export default ConstituentRelationsList;
